import { render, staticRenderFns } from "./DomainWhois.vue?vue&type=template&id=7de8a504&"
import script from "./DomainWhois.vue?vue&type=script&lang=js&"
export * from "./DomainWhois.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7de8a504')) {
      api.createRecord('7de8a504', component.options)
    } else {
      api.reload('7de8a504', component.options)
    }
    module.hot.accept("./DomainWhois.vue?vue&type=template&id=7de8a504&", function () {
      api.rerender('7de8a504', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Domains/DomainWhois.vue"
export default component.exports